import { useDispatch } from "react-redux";
import { useCallback,useState } from "react";
import axiosInstance from "../../../axios/axiosInstance";
import { setAuthUser } from "../../../redux/slices/AuthUser";
import { decodeToken } from "../../../helper/decodeToken";
import { showPopup } from "./showPopup";
import useNavigateBasedOnPath from "../helper/checkPrevPath";
import { useShowAlert } from "../../../hooks/useShowAlert";
import { normalizePhoneNumber } from "../../../helper/normalizePhoneNumber";

export const useSubmitForm = (onSuccess) => {
    const [loading, setLoading] = useState(false);
    const { showAlert } = useShowAlert();
    const dispatch = useDispatch();
    const navigateBasedOnPath = useNavigateBasedOnPath();
    const submitForm = useCallback(async (values) => {
        setLoading(true);
        // Determine if the identifier is an email or phone number
        const isEmail = values.identifier.includes("@") || values.identifier.includes(".");
        const phoneNumber = normalizePhoneNumber(values.countryCode, values.identifier);
        // Prepare the payload
        const payload = {
            password: values.password,
            identifier: isEmail ? values.identifier : phoneNumber
        };

        try {
            const res = await axiosInstance.post("/user/login", payload);
            const { id, exp } = await decodeToken(res.data?.token);
            localStorage.setItem("token", res.data?.token);

            const userResponse = await axiosInstance.get("/user/current", { skipAuthLogout: true });
            const user = userResponse.data?.user || res.data?.user || null;

            dispatch(setAuthUser({ user, exp, id })); // Set user to redux
            showPopup(user, dispatch); // Show dialog if user does not have required information
            onSuccess?.(user);
            navigateBasedOnPath(); // Check prev path to navigate to the correct path
        } catch (err) {
            showAlert("error", err.response?.data?.error || err.response?.data?.message || "An error occurred");
            setLoading(false); // Add this line to set loading to false on error
        }
        finally{
            setLoading(false);
        }
       
    }, [dispatch, navigateBasedOnPath, onSuccess, showAlert]);

    return { submitForm, loading };
};
